export default __webpack_public_path__ + "static/media/logo.a42650a5.jpeg";